import { setGuide, setGuides } from "reduxStore/state";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getGuides = () => async (dispatch, getState) => {
  try {
    const token = getState().token;

    const response = await fetch(`${BASE_URL}/guide`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to get guides");
    }

    const guides = await response.json();

    dispatch(setGuides(guides)); // Dispatch the action to update the state

    return guides;
  } catch (error) {
    console.error("Error while getting guides:", error);
    return null;
  }
};

export const getGuideById = (id) => async (dispatch, getState) => {
  try {
    const token = getState().token;

    const response = await fetch(`${BASE_URL}/guide/${id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to get guide");
    }

    const guide = await response.json();

    dispatch(setGuide(guide)); // Dispatch the action to update the state

    return guide;
  } catch (error) {
    console.error("Error while getting guide:", error);
    return null;
  }
};

export const createGuide = (guide) => async (dispatch, getState) => {
  try {
    const token = getState().token;

    const response = await fetch(`${BASE_URL}/guide`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(guide),
    });

    if (!response.ok) {
      throw new Error("Failed to create guide");
    }

    const createdGuide = await response.json();

    dispatch(setGuide(createdGuide)); // Add the new guide to the state

    // Fetch and update the full guide list
    dispatch(getGuides());

    return createdGuide;
  } catch (error) {
    console.error("Error while creating guide:", error);
    return null;
  }
};

export const updateGuide = (guide) => async (dispatch, getState) => {
  try {
    const token = getState().token;

    const response = await fetch(`${BASE_URL}/guide/${guide._id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(guide),
    });

    if (!response.ok) {
      throw new Error("Failed to update guide");
    }

    const updatedGuide = await response.json();

    dispatch(setGuide(updatedGuide)); // Dispatch the action to update the state

    return updatedGuide;
  } catch (error) {
    console.error("Error while updating guide:", error);
    return null;
  }
};

export const deleteGuide = (id) => async (dispatch, getState) => {
  try {
    const token = getState().token;

    if (!id) throw new Error("Guide ID is required for deletion");

    const response = await fetch(`${BASE_URL}/guide/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to delete guide");
    }

    dispatch(getGuides()); // Update the state with the new guide list

    return true;
  } catch (error) {
    console.error("Error while deleting guide:", error);
    return false;
  }
};
